import type { CSSProperties } from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";

import { NoteSignature } from "../../(signature)/NoteSignature";

type AddendumDisplayProps = {
  credentials: string | undefined;
  data: string;
  signature: string | undefined;
  style?: CSSProperties;
  textTestId: string | undefined;
};

export function AddendumDisplay({
  credentials,
  data,
  signature,
  style,
  textTestId,
}: AddendumDisplayProps) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-6" style={style}>
      <p className="body-md" {...getAutomationDataAttr(textTestId)}>
        {data}
      </p>

      {signature && (
        <ul className="tw:flex">
          <NoteSignature isProvider label="Signature">
            {signature}
            {credentials ? `, ${credentials}` : ""}
          </NoteSignature>
        </ul>
      )}
    </div>
  );
}
